<template>
  <div>
    <top-bar heading="Units"></top-bar>
    <div class="container-fluid mt-3">
      <div class="row card-deck mt-2">
        <div class="col-12 col-lg-3 mb-md-5" v-for="course in $store.state.studentCourses" :key="course.id">
          <router-link :to="'/training_plan/' + course.course_id" v-if="course.is_enabled || course.is_completed">
            <b-card no-body class="shadow h-100 w-100 pointer" :class="getBackgroundColor(course)">
              <b-card-body class="p-2 text-center">
                <h6>{{ course.course_name ? course.course_name : course.name }}</h6>
              </b-card-body>
              <b-card-footer class="text-center p-3">
                <div>
                  <div v-if="course.is_enabled">
                    <font-awesome-icon icon="unlock"></font-awesome-icon>
                    <p>Enabled</p>
                  </div>
                  <div v-else-if="course.is_completed && !course.competent_at">
                    <font-awesome-icon icon="check"></font-awesome-icon>
                    <p>Completed, Not Competent</p>
                  </div>
                  <div v-else-if="course.is_completed && course.competent_at">
                    <font-awesome-icon icon="check"></font-awesome-icon>
                    <p>Competent</p>
                  </div>
                  <div v-else-if="course.is_enrolled">
                    <font-awesome-icon icon="lock"></font-awesome-icon>
                    <p>Enrolled</p>
                  </div>
                </div>
              </b-card-footer>
            </b-card>
          </router-link>
          <div v-else>
            <b-card no-body class="shadow h-100 w-100 pointer" :class="getBackgroundColor(course)">
              <b-card-body class="p-2 text-center">
                <h6>{{ course.course_name ? course.course_name : course.name }}</h6>
              </b-card-body>
              <b-card-footer class="text-center p-3">
                <div>
                  <div v-if="course.is_enabled">
                    <font-awesome-icon icon="unlock"></font-awesome-icon>
                    <p>Enabled</p>
                  </div>
                  <div v-else-if="course.is_completed && !course.competent_at">
                    <font-awesome-icon icon="check"></font-awesome-icon>
                    <p>Completed, Not Competent</p>
                  </div>
                  <div v-else-if="course.is_completed && course.competent_at">
                    <font-awesome-icon icon="check"></font-awesome-icon>
                    <p>Competent</p>
                  </div>
                  <div v-else-if="course.is_enrolled">
                    <font-awesome-icon icon="lock"></font-awesome-icon>
                    <p>Enrolled</p>
                  </div>
                </div>
              </b-card-footer>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrainingUnits',
  data () {
    return {};
  },
  methods: {
    getBackgroundColor (user_course) {
      if (user_course.is_completed) return 'bg-success';
      if (user_course.is_enabled) return 'bg-primary';
      if (user_course.is_enrolled) return 'bg-info';
      return 'bg-platinum';
    }
  },
  mounted () {},
  metaInfo: {
    title: 'Units'
  }
};
</script>

<style lang="scss">
  .page-trainingunits {
    a {
      text-decoration: none; /* no underline */
    }

    .bg-primary {
      &:hover {
        border-color: #284362;
        background-color: #243852 !important;
      }
    }
  }
</style>
